import React from 'react';
import { useTranslation } from 'react-i18next';
import CasualtiesComponent from '../archive/CasualtiesComponent';

const IedComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.ied_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>IED Type</th>
            {report.ied_type ? <td>{t(`ied.${report.ied_type.toLowerCase()}`)}</td> : <td>-</td>}
          </tr>
          <tr>
            <th>Status</th>
            {report.status ? <td>{t(`ied.${report.status.toLowerCase()}`)}</td> : <td>-</td>}
          </tr>
          <CasualtiesComponent casualties={report.casualties} />
        </tbody>
      </table>
    </div>
  );
};

export default IedComponent;
